"use strict";

exports.__esModule = true;
exports.useCreateAnimation = useCreateAnimation;

var _react = require("react");

var _reactHooks = require("@okee-uikit/react-hooks");

var _animation = require("../../../models/animation");

var _excluded = ["onReady", "onStart", "onEnd", "validTarget"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function useCreateAnimation(elem, options) {
  var animation = (0, _reactHooks.useSingleton)(function () {
    return new _animation.Animation();
  });

  var onReady = options.onReady,
      onStart = options.onStart,
      onEnd = options.onEnd,
      validTarget = options.validTarget,
      extra = _objectWithoutPropertiesLoose(options, _excluded);

  var elemGetter = (0, _reactHooks.useContainer)(elem);
  var onReadyCallback = (0, _reactHooks.useRefCallback)(onReady);
  var onStartCallback = (0, _reactHooks.useRefCallback)(onStart);
  var onEndCallback = (0, _reactHooks.useRefCallback)(onEnd);
  (0, _react.useEffect)(function () {
    animation.setEle(elemGetter());
    animation.updateOptions(_extends({}, extra, {
      validTarget: validTarget === null || validTarget === void 0 ? void 0 : validTarget.current
    }));
  });
  (0, _react.useEffect)(function () {
    animation.addListener('animate-ready', onReadyCallback);
    animation.addListener('animate-start', onStartCallback);
    animation.addListener('animate-end', onEndCallback);
    return function () {
      animation.removeListener('animate-ready', onReadyCallback);
      animation.removeListener('animate-start', onStartCallback);
      animation.removeListener('animate-end', onEndCallback);
    };
  }, []);
  return animation;
}